module.exports = __webpack_public_path__ + "img/w46.c3003053.svg";